var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _g3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect, _g4, _rect2, _rect3, _rect4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomePage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 194,
    viewBox: "0 0 362 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_54_3210)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 12,
    width: 66,
    height: 162,
    rx: 8,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.625 30.0978C319.258 27.6805 315.106 26.6184 310.992 27.1226C306.879 27.6268 303.106 29.6604 300.423 32.8192C297.741 35.9779 296.345 40.0305 296.514 44.1712C296.682 48.312 298.403 52.2377 301.333 55.1679C304.264 58.0981 308.19 59.8183 312.331 59.9864C316.471 60.1546 320.524 58.7584 323.682 56.0754C326.841 53.3925 328.874 49.6192 329.378 45.5058C329.881 41.3923 328.819 37.2399 326.401 33.8741L321.041 37.7244C322.491 39.744 323.129 42.2354 322.827 44.7035C322.524 47.1715 321.304 49.4355 319.409 51.0453C317.514 52.655 315.083 53.4927 312.598 53.3918C310.114 53.291 307.758 52.2589 306 50.5007C304.242 48.7426 303.209 46.3872 303.108 43.9027C303.007 41.4183 303.844 38.9868 305.454 37.0915C307.064 35.1962 309.327 33.9761 311.795 33.6735C314.264 33.371 316.755 34.0083 318.775 35.4587L322.625 30.0978Z",
    fill: "#D4FDE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.753 77.935C317.095 75.9877 312.838 75.4883 308.828 76.536C304.819 77.5838 301.35 80.1019 299.113 83.5899C296.875 87.0779 296.031 91.2803 296.75 95.3617C297.469 99.443 299.697 103.105 302.992 105.618C306.287 108.132 310.407 109.314 314.533 108.929C318.659 108.544 322.489 106.62 325.262 103.54C328.035 100.46 329.548 96.4498 329.499 92.306C329.45 88.1621 327.844 84.1883 324.999 81.1745L320.2 85.7047C321.906 87.513 322.87 89.8972 322.899 92.3836C322.929 94.8699 322.021 97.2762 320.357 99.1241C318.694 100.972 316.396 102.126 313.92 102.357C311.444 102.588 308.972 101.879 306.995 100.371C305.018 98.8627 303.681 96.6658 303.25 94.217C302.819 91.7682 303.325 89.2467 304.668 87.154C306.01 85.0612 308.091 83.5503 310.497 82.9216C312.903 82.293 315.457 82.5926 317.652 83.761L320.753 77.935Z",
    fill: "#DBEFF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.667 129.833C321.737 126.902 317.811 125.182 313.67 125.014C309.53 124.845 305.477 126.241 302.318 128.924C299.16 131.607 297.126 135.38 296.622 139.493C296.118 143.607 297.181 147.759 299.598 151.125C302.016 154.491 305.611 156.824 309.67 157.661C313.729 158.497 317.954 157.775 321.505 155.639C325.057 153.503 327.674 150.108 328.837 146.131C330 142.153 329.624 137.883 327.783 134.171L321.87 137.102C322.974 139.33 323.2 141.892 322.502 144.278C321.804 146.665 320.234 148.702 318.103 149.983C315.973 151.265 313.438 151.698 311.002 151.196C308.567 150.695 306.409 149.295 304.959 147.275C303.508 145.256 302.871 142.764 303.173 140.296C303.476 137.828 304.696 135.564 306.591 133.954C308.486 132.345 310.918 131.507 313.402 131.608C315.887 131.709 318.242 132.741 320 134.5L324.667 129.833Z",
    fill: "#ECDCF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M313 30.3C313 28.4775 314.492 26.9668 316.278 27.3289C318.034 27.6848 319.727 28.3257 321.289 29.233C323.806 30.6956 325.892 32.7984 327.334 35.3277C328.776 37.8571 329.523 40.7229 329.499 43.6344C329.485 45.4404 329.174 47.2241 328.586 48.9162C327.987 50.6378 325.928 51.1521 324.359 50.2238C322.791 49.2954 322.336 47.2635 322.7 45.4777C322.827 44.8557 322.894 44.2205 322.9 43.5806C322.914 41.8338 322.466 40.1142 321.6 38.5966C320.735 37.079 319.484 35.8174 317.973 34.9398C317.42 34.6184 316.839 34.3526 316.239 34.1449C314.517 33.5486 313 32.1225 313 30.3Z",
    fill: "#00C282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M313 79.3C313 77.4775 314.492 75.9668 316.278 76.3289C318.773 76.8348 321.133 77.9145 323.162 79.5009C326.064 81.7694 328.123 84.9437 329.012 88.5181C329.901 92.0925 329.569 95.8615 328.067 99.2249C326.566 102.588 323.983 105.353 320.729 107.078C317.474 108.803 313.736 109.39 310.11 108.745C306.484 108.1 303.177 106.26 300.718 103.518C298.258 100.776 296.787 97.2907 296.538 93.6158C296.364 91.0459 296.794 88.4869 297.776 86.1378C298.479 84.4562 300.566 84.0691 302.075 85.092C303.583 86.1148 303.912 88.1708 303.439 89.9309C303.158 90.9784 303.048 92.0723 303.123 93.1695C303.272 95.3744 304.155 97.4659 305.631 99.1109C307.106 100.756 309.09 101.86 311.266 102.247C313.442 102.634 315.685 102.282 317.637 101.247C319.59 100.212 321.14 98.553 322.04 96.535C322.941 94.5169 323.141 92.2555 322.607 90.1108C322.074 87.9662 320.838 86.0617 319.097 84.7006C318.231 84.0232 317.264 83.4999 316.239 83.1449C314.517 82.5486 313 81.1225 313 79.3Z",
    fill: "#3DADDC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M313 128.3C313 126.477 314.492 124.967 316.278 125.329C317.708 125.619 319.097 126.098 320.41 126.757C322.709 127.913 324.706 129.59 326.241 131.655C327.776 133.72 328.807 136.115 329.252 138.649C329.696 141.184 329.542 143.787 328.801 146.251C328.06 148.715 326.753 150.972 324.985 152.841C323.216 154.71 321.035 156.139 318.616 157.015C316.196 157.891 313.606 158.188 311.051 157.884C309.592 157.711 308.169 157.344 306.816 156.798C305.127 156.114 304.715 154.032 305.72 152.511C306.726 150.991 308.777 150.638 310.543 151.09C310.965 151.198 311.395 151.279 311.83 151.331C313.363 151.513 314.918 151.334 316.37 150.809C317.821 150.283 319.13 149.426 320.191 148.304C321.252 147.183 322.036 145.829 322.481 144.351C322.925 142.872 323.018 141.31 322.751 139.79C322.484 138.269 321.866 136.832 320.945 135.593C320.023 134.354 318.825 133.348 317.446 132.654C317.054 132.458 316.651 132.288 316.239 132.145C314.517 131.549 313 130.123 313 128.3Z",
    fill: "#A152D3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_54_3210)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 12,
    width: 250,
    height: 96,
    rx: 8,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_54_3210)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 120,
    width: 250,
    height: 54,
    rx: 8,
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 165L35.5 133.5C35.5 131.015 37.5147 129 40 129C42.4853 129 44.5 131.015 44.5 133.5L44.5 165L35.5 165Z",
    fill: "#D4FDE6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 165L35.5 157.5C35.5 155.015 37.5147 153 40 153C42.4853 153 44.5 155.015 44.5 157.5L44.5 165L35.5 165Z",
    fill: "#00C282"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 165L64.5 133.5C64.5 131.015 66.5147 129 69 129C71.4853 129 73.5 131.015 73.5 133.5L73.5 165L64.5 165Z",
    fill: "#D4FDE6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 165L64.5 150.5C64.5 148.015 66.5147 146 69 146C71.4853 146 73.5 148.015 73.5 150.5L73.5 165L64.5 165Z",
    fill: "#00C282"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 165L93.5 133.5C93.5 131.015 95.5147 129 98 129C100.485 129 102.5 131.015 102.5 133.5L102.5 165L93.5 165Z",
    fill: "#D4FDE6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 165L93.5 145.5C93.5 143.015 95.5147 141 98 141C100.485 141 102.5 143.015 102.5 145.5L102.5 165L93.5 165Z",
    fill: "#00C282"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 165L122.5 133.5C122.5 131.015 124.515 129 127 129C129.485 129 131.5 131.015 131.5 133.5L131.5 165L122.5 165Z",
    fill: "#D4FDE6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 165L122.5 141.5C122.5 139.015 124.515 137 127 137C129.485 137 131.5 139.015 131.5 141.5L131.5 165L122.5 165Z",
    fill: "#00C282"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 165L151.5 133.5C151.5 131.015 153.515 129 156 129C158.485 129 160.5 131.015 160.5 133.5L160.5 165L151.5 165Z",
    fill: "#D4FDE6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 165L151.5 157.5C151.5 155.015 153.515 153 156 153C158.485 153 160.5 155.015 160.5 157.5L160.5 165L151.5 165Z",
    fill: "#00C282"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 165L180.5 133.5C180.5 131.015 182.515 129 185 129C187.485 129 189.5 131.015 189.5 133.5L189.5 165L180.5 165Z",
    fill: "#D4FDE6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 165L180.5 151.5C180.5 149.015 182.515 147 185 147C187.485 147 189.5 149.015 189.5 151.5L189.5 165L180.5 165Z",
    fill: "#00C282"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M209.5 165L209.5 133.5C209.5 131.015 211.515 129 214 129C216.485 129 218.5 131.015 218.5 133.5L218.5 165L209.5 165Z",
    fill: "#D4FDE6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209.5 165L209.5 153.5C209.5 151.015 211.515 149 214 149C216.485 149 218.5 151.015 218.5 153.5L218.5 165L209.5 165Z",
    fill: "#00C282"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5 165L238.5 133.5C238.5 131.015 240.515 129 243 129C245.485 129 247.5 131.015 247.5 133.5L247.5 165L238.5 165Z",
    fill: "#D4FDE6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5 165L238.5 138.5C238.5 136.015 240.515 134 243 134C245.485 134 247.5 136.015 247.5 138.5L247.5 165L238.5 165Z",
    fill: "#00C282"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54_3210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 21,
    width: 224,
    height: 77
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 21,
    width: 223,
    height: 77,
    fill: "#C4C4C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54_3210)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M71.0845 80.2002C53.7567 79.9398 37.2792 92.1682 32.8198 97.2672V113.383L253.208 110.935V24.8867C232.535 24.4947 228.993 63.9264 213.147 63.9264C197.3 63.9264 182.993 76.7283 174.924 83.4546C168.298 89.4432 159.847 90.7234 156.449 90.6149C140.65 90.8753 128.631 77.4877 124.597 70.7614C121.029 63.2104 117.013 61.6482 115.041 61.6482C111.732 61.6434 106.759 63.8615 101.663 71.4124C96.5665 78.9632 88.4972 81.0679 85.0996 81.1764C80.3473 81.3282 74.6945 80.2001 71.0845 80.2002Z",
    fill: "#00C282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5744 80.1302L70.5593 81.1301C70.5644 81.1302 70.5694 81.1302 70.5744 81.1302L70.5744 80.1302ZM84.5199 81.1065L84.5519 82.1059L84.5199 81.1065ZM114.312 61.5783L114.311 62.5783H114.312L114.312 61.5783ZM123.821 70.6914L122.916 71.1169C122.93 71.1467 122.945 71.1757 122.962 71.204L123.821 70.6914ZM155.515 90.545L155.547 89.5455C155.531 89.545 155.514 89.5448 155.498 89.5451L155.515 90.545ZM173.897 83.3847L173.255 82.6181C173.245 82.6267 173.235 82.6355 173.225 82.6445L173.897 83.3847ZM33.2544 97.8537C35.3761 95.4155 40.4803 91.1537 47.2092 87.5347C53.9311 83.9194 62.1687 81.0034 70.5593 81.1301L70.5895 79.1303C61.7386 78.9967 53.1575 82.0646 46.2619 85.7733C39.3733 89.4781 34.0611 93.88 31.7456 96.5408L33.2544 97.8537ZM70.5744 81.1302C72.3014 81.1302 74.5312 81.4025 77.014 81.6695C79.458 81.9323 82.1098 82.1843 84.5519 82.1059L84.4878 80.107C82.2013 80.1804 79.6764 79.9442 77.2278 79.681C74.818 79.4218 72.4395 79.1302 70.5744 79.1302L70.5744 81.1302ZM84.5519 82.1059C88.1679 81.9899 96.5372 79.7824 101.831 71.8999L100.171 70.7849C95.3223 78.0041 87.6332 80.006 84.4878 80.107L84.5519 82.1059ZM101.831 71.8999C106.8 64.5012 111.479 62.5741 114.311 62.5783L114.314 60.5783C110.562 60.5728 105.344 63.0818 100.171 70.7849L101.831 71.8999ZM114.312 62.5783C115.737 62.5783 119.456 63.7573 122.916 71.1169L124.726 70.266C121.086 62.5236 116.811 60.5783 114.312 60.5783L114.312 62.5783ZM122.962 71.204C125.029 74.6674 129.106 79.795 134.672 84.0338C140.241 88.2746 147.376 91.6799 155.531 91.5448L155.498 89.5451C147.934 89.6704 141.228 86.5121 135.884 82.4426C130.537 78.3712 126.627 73.4418 124.679 70.1789L122.962 71.204ZM155.483 91.5445C159.051 91.659 167.738 90.3313 174.57 84.1248L173.225 82.6445C166.872 88.4152 158.74 89.648 155.547 89.5455L155.483 91.5445ZM174.54 84.1512C178.539 80.8007 184.568 76.0001 191.541 72.0394C198.527 68.071 206.366 65 214 65V63C205.866 63 197.669 66.2582 190.553 70.3004C183.423 74.3505 177.285 79.2422 173.255 82.6181L174.54 84.1512ZM214 65C218.419 65 221.849 62.1829 224.77 58.3596C227.693 54.5342 230.293 49.4476 232.97 44.5143C235.677 39.5282 238.475 34.6704 241.838 31.0792C245.179 27.511 248.998 25.2775 253.766 25.3684L253.804 23.3688C248.287 23.2636 243.961 25.8861 240.378 29.7121C236.817 33.5149 233.911 38.5895 231.213 43.5603C228.486 48.5838 225.982 53.4786 223.181 57.1454C220.378 60.8142 217.465 63 214 63V65Z",
    fill: "#00C282"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M185.162 78.6734C187.893 78.6734 190.11 76.4624 190.11 73.7317C190.11 71.0011 187.893 68.79 185.162 68.79C182.431 68.79 180.214 71.0011 180.214 73.7317C180.214 76.4624 182.431 78.6734 185.162 78.6734Z",
    stroke: "#00C282",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_54_3210)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-1_54_3210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.162,
    cy: 73.7314,
    rx: 2.3028,
    ry: 2.29931
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.162,
    cy: 73.7314,
    rx: 2.3028,
    ry: 2.29931,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.465 73.7314C183.465 72.7865 184.231 72.0308 185.162 72.0308V80.0308C188.637 80.0308 191.465 77.2162 191.465 73.7314H183.465ZM185.162 72.0308C186.094 72.0308 186.859 72.7865 186.859 73.7314H178.859C178.859 77.2162 181.687 80.0308 185.162 80.0308V72.0308ZM186.859 73.7314C186.859 74.6764 186.094 75.4321 185.162 75.4321V67.4321C181.687 67.4321 178.859 70.2467 178.859 73.7314H186.859ZM185.162 75.4321C184.231 75.4321 183.465 74.6764 183.465 73.7314H191.465C191.465 70.2467 188.637 67.4321 185.162 67.4321V75.4321Z",
    fill: "#00C282",
    mask: "url(#path-30-inside-1_54_3210)"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 25,
    width: 32,
    height: 15,
    rx: 7.5,
    fill: "#D4FDE6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 25,
    width: 32,
    height: 15,
    rx: 7.5,
    fill: "#F3F5F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.5,
    y: 25,
    width: 32,
    height: 15,
    rx: 7.5,
    fill: "#F3F5F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_54_3210",
    x: 263.5,
    y: 0,
    width: 98,
    height: 194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54_3210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54_3210",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_54_3210",
    x: 0.5,
    y: 0,
    width: 282,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54_3210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54_3210",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_54_3210",
    x: 0.5,
    y: 108,
    width: 282,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54_3210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54_3210",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_54_3210",
    x: 180.859,
    y: 70.4321,
    width: 8.60571,
    height: 8.59863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.317647 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54_3210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54_3210",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePage2);
export default __webpack_public_path__ + "static/media/welcome_page2.b7205a8dc914856f03046cbf8cc57dc5.svg";
export { ForwardRef as ReactComponent };